import React, { useState } from "react";
import { fontsName } from "../../assets/fonts/fontsName";
// import img5 from "../../assets/images/blog/best1.jpg";
import {
  Backdrop,
  Box,
  Divider,
  Modal,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";

const ChartInfoModal = ({ open, onClose, personInfo }) => {
  const theme = useTheme();
  const responsive = useMediaQuery(theme.breakpoints.only("xs"));
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{ overflow: "scroll" }}
    >
      <>
        <Box style={{ width: "100%", textAlign: "right", padding: "10px 0px" }}>
          <Close
            style={{ color: "#fff", fontSize: "24px", cursor: "pointer" }}
            onClick={() => onClose()}
          />
        </Box>
        <Paper
          style={
            responsive
              ? {
                width: "90%",
                borderRadius: "15px",
                margin: "15px auto",
                padding: "30px 10px",
              }
              : {
                width: "50%",
                borderRadius: "15px",
                margin: "15px auto",
                padding: "30px 10px",
              }
          }
        >
          <Box
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <Typography
              style={{
                padding: "10px",
                margin: "0px auto",
                direction: "rtl",
                fontFamily: fontsName.VazirBold,
              }}
            >
              مشاهده اطلاعات سازمانی
            </Typography>

            <Box
              style={{
                width: "80%",
                margin: "10px auto",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={personInfo.pictureLink}
                style={{ width: "60%", border: "1px solid #1A237E" }}
              />
            </Box>
            <Divider
              variant="middle"
              style={{ backgroundColor: "#64B5F6", margin: "15px 30px" }}
            />

            <Box
              style={{
                width: "80%",
                margin: "30px auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  direction: "rtl",
                  flexDirection: "column",
                  textAlign: "right",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: fontsName.VazirBold,
                  }}
                >
                  نام و نام خانوادگی :
                </Typography>
                <Typography
                  style={{
                    fontSize: "18px",
                    marginTop: "8px",
                    fontFamily: fontsName.VazirLight,
                  }}
                >
                  {/* متن لورم ایپسوم فارسی */}
                  {personInfo.fullName}
                </Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  direction: "rtl",
                  flexDirection: "column",
                  textAlign: "right",
                  marginTop: "25px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: fontsName.VazirBold,
                  }}
                >
                  مسئولیت :
                </Typography>
                <Typography
                  style={{
                    fontSize: "16px",
                    marginTop: "8px",
                    fontFamily: fontsName.VazirLight,
                  }}
                >
                  {/* متن لورم ایپسوم فارسی */}
                  {personInfo.postType !== ""
                    ? personInfo.post + " " + personInfo.postType
                    : "_"}
                </Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  direction: "rtl",
                  flexDirection: "column",
                  marginTop: "25px",
                  textAlign: "right",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: fontsName.VazirBold,
                  }}
                >
                  سوابق تحصیلی :
                </Typography>
                <Typography
                  style={{
                    fontSize: "18px",
                    marginTop: "8px",
                    textAlign: "justify",
                    fontFamily: fontsName.VazirLight,
                  }}
                >
                  {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است */}
                  {personInfo.academicHistory}
                </Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  direction: "rtl",
                  flexDirection: "column",
                  marginTop: "25px",
                  textAlign: "right",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: fontsName.VazirBold,
                  }}
                >
                  سوابق شغلی :
                </Typography>
                <Typography
                  style={{
                    fontSize: "18px",
                    marginTop: "8px",
                    textAlign: "justify",
                    fontFamily: fontsName.VazirLight,
                  }}
                >
                  {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است. */}
                  {personInfo.jobHistory}
                </Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  direction: "rtl",
                  flexDirection: "column",
                  marginTop: "25px",
                  textAlign: "right",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: fontsName.VazirBold,
                  }}
                >
                  توضیحات :
                </Typography>
                <Typography
                  style={{
                    fontSize: "18px",
                    marginTop: "8px",
                    textAlign: "justify",
                    fontFamily: fontsName.VazirLight,
                  }}
                >
                  {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است */}
                  {personInfo.description}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </>
    </Modal>
  );
};

export default ChartInfoModal;
